import application from '../../api/application'
import lodash from 'lodash';

const state = {
  basicInfo: {},
  platformInfo: {},
  configInfo: {},
  appList: [], // 应用列表
  pageTotal: 0,
  loading: true,
  infoLoading: true
};

const actions = {
  // 获取应用列表
  async getAppList ({ commit }, payload) {
    const params = lodash.cloneDeep(payload);
    delete params.init;
    const response = await application.getAppList(params);
    if (response.status === 200) {
      const { data } = response;
      commit('UPDATE_APP', {
        appList: data.data,
        total: data.total
      });
      commit('UPDATE_LOADING', {
        loading: false
      });
    }
  },
  // 删除一个应用
  async delApplication ({ dispatch, commit, state }, payload) {
    const response = await application.delApplication({appId: payload.appId});
    if (response.status === 200) {
      commit('DELETE_APP', payload);
    }
  },
  // 获取应用信息
  async getPlatform ({ commit }, payload) {
    const response = await application.getPlatform(payload);
    if (response.status === 200) {
      const { data } = response;
      commit('APPLICATION_INFO', {
        data: data.data
      });
      commit('UPDATE_INFO_LOADING', {
        infoLoading: false
      });
    }
  }
};

const mutations = {
  'UPDATE_APP': (state, payload) => {
    state.appList = payload.appList
    state.pageTotal = payload.total
  },
  'APPLICATION_INFO': (state, payload) => {
    const appInfo = payload.data
    state.basicInfo = appInfo.basicInfo
    state.platformInfo = appInfo.platformInfo
    state.configInfo = appInfo.advanced_configuration
  },
  'DELETE_APP': (state, payload) => {
    state.appList.splice(payload.index, 1);
  },
  'UPDATE_LOADING': (state, payload) => {
    state.loading = payload.loading;
  },
  'UPDATE_INFO_LOADING': (state, payload) => {
    state.infoLoading = payload.infoLoading;
  }
};

export default {
  state,
  actions,
  mutations
};



// WEBPACK FOOTER //
// ./src/store/modules/application.js